import { render, staticRenderFns } from "./myRegistration.vue?vue&type=template&id=f0af0d80&scoped=true"
import script from "./myRegistration.vue?vue&type=script&lang=js"
export * from "./myRegistration.vue?vue&type=script&lang=js"
import style0 from "./myRegistration.vue?vue&type=style&index=0&id=f0af0d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0af0d80",
  null
  
)

export default component.exports